export default __webpack_public_path__ + "static/media/996.8ae4c2e1.png";